// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3798":"09c463d6","6722":"09c463d6","7790":"ed8fe78d","9834":"ed8fe78d"}[chunkId] + ".chunk.css";
};